module.exports = __webpack_public_path__ + "img/DIRE-mockup-ipad2.94a43c6e.png";